/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import { Flex } from '../..';

/**
 * Manages the layout of the immediate children along the vertical or horizontal axis,
 * with optional spacing between the children.
 *
 * @param {{
 *  direction?: import("csstype").Property.FlexDirection | Array<import("csstype").Property.FlexDirection | null>;
 *  spacing?: number | Array<number>;
 *  alignItems?: import("csstype").Property.AlignItems | Array<import("csstype").Property.AlignItems>;
 *  justifyContent?: import("csstype").Property.JustifyContent | Array<import("csstype").Property.JustifyContent>;
 *  [x: string]: any;
 *  children: React.ReactNode;
 * }} props
 * @returns
 */
export default function Stack({
  direction = 'column',
  spacing = 3,
  alignItems,
  justifyContent,
  children,
  ...rest
}) {
  return (
    <Flex
      gap={spacing}
      direction={direction}
      sx={{ alignItems, justifyContent }}
      {...rest}
    >
      {children}
    </Flex>
  );
}
